import React from "react";
import styled from "styled-components";
import { Grid, Link as MuiLink, Typography } from "@material-ui/core";

const Link = styled(MuiLink)`
  &:hover {
    cursor: pointer;
  }
`;

interface Props {
  title: string;
  statuses?: React.ReactNode[] | null;
  color?: "primary" | "secondary";
  onClick?: () => void;
}

const ListCardTitle: React.FC<Props> = ({
  title,
  statuses,
  color = "primary",
  onClick,
}) => {
  return (
    <Grid container>
      <Grid item>
        {onClick ? (
          <Link
            variant="h6"
            color={color}
            onClick={() => onClick()}
            data-cy="cardTitle"
          >
            {title}
          </Link>
        ) : (
          <Typography variant="h6" color={color}>
            {title}
          </Typography>
        )}
      </Grid>

      {statuses?.map((status, index) => (
        <Grid key={"status_" + index} item>
          {status}
        </Grid>
      ))}
    </Grid>
  );
};

export default ListCardTitle;
